module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-bg"
  }, [_c('div', {
    ref: "pages",
    staticClass: "pages"
  }, [(_vm.canRun) ? _c('span', {
    staticClass: "page-items",
    on: {
      "click": function($event) {
        _vm.run();
        _vm.$forceUpdate();
      }
    }
  }, [_vm._v("runCode()")]) : _vm._e(), _vm._v(" "), (_vm.canRun) ? _c('span', {
    staticClass: "page-items",
    on: {
      "click": function($event) {
        _vm.canRun = !_vm.canRun;
        _vm.$forceUpdate();
      }
    }
  }, [_vm._v("Execution Enabled")]) : _vm._e(), _vm._v(" "), (!_vm.canRun) ? _c('span', {
    staticClass: "page-items",
    staticStyle: {
      "color": "hotpink"
    },
    on: {
      "click": function($event) {
        _vm.canRun = !_vm.canRun;
        _vm.$forceUpdate();
      }
    }
  }, [_vm._v("Execution Disabled")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "page-items",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('span', {
    staticClass: "page-items",
    on: {
      "click": function($event) {
        _vm.addPage()
      }
    }
  }, [_vm._v("(add)")]), _vm._v(" "), _vm._l((_vm.pages), function(page, index) {
    return _c('span', {
      staticClass: "page-items",
      class: {
        'item-selected': _vm.currentPageIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectPage(index)
        }
      }
    }, [_vm._v("(" + _vm._s(index + 1) + ": " + _vm._s(_vm.getFirstLine(page)) + ")")])
  }), _vm._v(" "), (_vm.pages.length > 0) ? _c('span', {
    staticClass: "page-del",
    on: {
      "click": function($event) {
        _vm.removeThisPage()
      }
    }
  }, [_vm._v("remove")]) : _vm._e()], 2), _vm._v(" "), _c('iframe', {
    ref: "iframe",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    ref: "firepadDiv",
    staticClass: "firepad-div",
    style: ({
      height: _vm.coderHeight
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2677d1ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive/Firepad.vue
// module id = 300
// module chunks = 3